var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#929497",
  d: "M0 4h10v2H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#929497",
  d: "M4 10V0h2v10z"
})));
export { SvgPlus as ReactComponent };
export default __webpack_public_path__ + "81fa78172b008077628404921b2ee6a7.svg";